// extracted by mini-css-extract-plugin
export var modalContainer = "ModalOverlay-module--modalContainer--230f7";
export var modalDecenterSpace = "ModalOverlay-module--modalDecenterSpace--bd1d6";
export var overlay = "ModalOverlay-module--overlay--18629";